import type { Elemental } from '../types/elemental'
import { useProfileFeed } from './query/useProfileFeed'

export const useGetOnlyKMSElementals = () => {
  const user = useUser()
  let allPrompts: Elemental[] = []
  const { data: kmsElementals, isLoading: isLoadingKMS, refetch: refetchKMS } = useProfileFeed(user.value?.id ?? '', {
    mode: 'library',
    is_knowledge_base: true,
  }, {
    enabled: computed(() => !!user.value?.id),
  })

  const kmsElementalsFiltered = computed(() => {
    allPrompts = []

    kmsElementals.value?.forEach((item: any) => {
      if (item.id === 'all' && item.prompts?.length)
        return allPrompts.push(...item.prompts)
      if (item.id === 'all' && !item.prompts?.length)
        return null
      return allPrompts.push(item)
    })

    return allPrompts
  })

  return {
    kmsElementals: kmsElementalsFiltered,
    isLoading: isLoadingKMS,
    refetchKMS,
  }
}
